import { AiOutlinePlus } from 'react-icons/ai'

import { Container } from './style'

export function ButtonPanelPage({ label, svg, handleClickButton }) {

    return <Container  
                onClick={() => handleClickButton()} 
            >
            {
                svg ?
                    <AiOutlinePlus />

                :<></>
            }
            
            {label}
        </Container>
}